document.addEventListener('DOMContentLoaded', () => {
  const FADE_SELECTOR = '[data-fade-up], [data-gsap-reveal], [data-fade-left], [data-fade-right], [data-fade-down]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  gsap.registerPlugin(ScrollTrigger);

  function getRevealEffect(element) {
    if (element.hasAttribute('data-fade-left')) return 'right_to_left';
    if (element.hasAttribute('data-fade-right')) return 'left_to_right';
    if (element.hasAttribute('data-fade-down')) return 'top_to_bottom';
    return element.dataset.gsapReveal || 'fade_up';
  }

  function getRevealFromVars(element) {
    const effect = getRevealEffect(element);

    if (effect === 'right_to_left') return { x: 48, y: 0, opacity: 0 };
    if (effect === 'left_to_right') return { x: -48, y: 0, opacity: 0 };
    if (effect === 'top_to_bottom') return { x: 0, y: -48, opacity: 0 };
    if (effect === 'bottom_to_top') return { x: 0, y: 48, opacity: 0 };

    return { x: 0, y: 25, opacity: 0 };
  }

  function getRevealDelay(index, element) {
    const customDelay =
      parseFloat(element.getAttribute('data-fade-up')) ||
      parseFloat(element.getAttribute('data-gsap-delay')) ||
      parseFloat(element.getAttribute('data-fade-left')) ||
      parseFloat(element.getAttribute('data-fade-right')) ||
      parseFloat(element.getAttribute('data-fade-down')) ||
      0;

    return index * 0.2 + customDelay;
  }

  function showWithoutAnimation(elements) {
    elements.forEach((element) => {
      gsap.set(element, { x: 0, y: 0, opacity: 1, clearProps: 'transform' });
      element.classList.add('animated');
    });
  }

  if (reducedMotion) {
    document.querySelectorAll('[data-fade-section], [data-fade-cards]').forEach((section) => {
      showWithoutAnimation(Array.from(section.querySelectorAll(FADE_SELECTOR)));
    });
    return;
  }

  // Fade and directional reveal animations with stagger + per-element delay.
  document.querySelectorAll('[data-fade-cards]').forEach((section) => {
    const elements = section.querySelectorAll(FADE_SELECTOR);
    if (elements.length > 2) {
      const totalElements = elements.length;
      const allElements = Array.from(elements);

      // Get the last two elements in their original order (9th and 10th)
      const lastTwo = allElements.slice(-3);
      
      // Get the rest of the elements (1st through 8th)
      const remainingElements = allElements.slice(0, totalElements - 3);

      // Create a new, reordered array for the animation
      // The order will be [9th, 10th, 1st, 2nd, ..., 8th]
      const animationOrder = [...lastTwo, ...remainingElements];

      gsap.fromTo(animationOrder, {
        x: (i, el) => getRevealFromVars(el).x,
        y: (i, el) => getRevealFromVars(el).y,
        opacity: 0,
      }, {
        x: 0,
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: 'power3.out',
        delay: getRevealDelay,
        scrollTrigger: {
          trigger: section,
          start: 'top 90%',
          toggleActions: 'play none none none',
          once: true,
        },
        onComplete: function() {
          elements.forEach(el => el.classList.add('animated'));
        }
      });
    }
  });

  document.querySelectorAll('[data-fade-section]').forEach((section) => {
    let elements = section.querySelectorAll(FADE_SELECTOR);
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    // 모바일에서 product__info-container는 애니메이션에서 제외 (fixed 버튼이 제대로 작동하도록)
    if (isMobile) {
      elements = Array.from(elements).filter(el => !el.classList.contains('product__info-container'));
      // product__info-container는 바로 보이도록 설정
      const infoContainer = section.querySelector('.product__info-container');
      if (infoContainer) {
        infoContainer.style.opacity = '1';
        infoContainer.style.transform = 'none';
        infoContainer.classList.add('animated');
      }
    }

    if (elements.length) {
      gsap.fromTo(elements, {
        x: (i, el) => getRevealFromVars(el).x,
        y: (i, el) => getRevealFromVars(el).y,
        opacity: 0,
      }, {
        x: 0,
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: 'power3.out',
        delay: getRevealDelay,
        scrollTrigger: {
          trigger: section,
          start: 'top 85%',
          toggleActions: 'play none none none',
          once: true,
        },
        onComplete: function() {
          // Add animated class to all elements when animation completes
          elements.forEach(el => el.classList.add('animated'));
        }
      });
    }
  });
});

function attachHoverListeners() {
  const buttons = document.querySelectorAll("[data-btn-filler]");

  buttons.forEach((button) => {
    if (button.dataset.hoverBound) return;
    button.dataset.hoverBound = "true";

    // Set initial state to white (hover-out)
    button.classList.add("hover-out");

    const handleInteraction = () => {
      // Change to black (hover-in) on click/touch
      button.classList.remove("hover-out");
      button.classList.add("hover-in");

      // Return to white (hover-out) after 0.3 seconds
      setTimeout(() => {
        button.classList.remove("hover-in");
        button.classList.add("hover-out");
      }, 300);
    };

    button.addEventListener("click", handleInteraction);
    button.addEventListener("touchstart", handleInteraction, { passive: true });
  });
}

attachHoverListeners();

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === "childList" || mutation.type === "subtree") {
      attachHoverListeners();
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// new animation logic for headings
document.querySelectorAll("section").forEach(section => {
  ScrollTrigger.create({
    trigger: section,
    start: "top 75%",
    once: true,
    onEnter: () => section.classList.add("is-active")
  });
});

// Header dim effect - only at top of page
function updateHeaderDim() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  if (scrollTop <= 10) {
    document.body.classList.add('is-top');
  } else {
    document.body.classList.remove('is-top');
  }
}

// Initial check
updateHeaderDim();

// Listen for scroll
window.addEventListener('scroll', updateHeaderDim, { passive: true });

// Listen for resize (in case of viewport change)
window.addEventListener('resize', updateHeaderDim, { passive: true });
